import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'

function requiredValidator(val) {
	// #58969 since _.isEmpty() does not seem to be working as expected
	// for numbers, convert the value to a string if possible
	// (Otherwise keep the original value)
	const stringVal = val?.toString() ?? val
	if (_.isEmpty(stringVal)) {
		return i18n.get('common.error.thisFieldRequired')
	}
}

export default requiredValidator

requiredValidator.__filename__ = 'components/validators/required-validator.js'
